import { createContext, useCallback, useContext, useMemo, useState } from "react";

export const LARGURA_MENU_EXPANDIDO = 260;
export const LARGURA_MENU_RECOLHIDO = 76;

const CHAVE_STORAGE = "menu-lateral-recolhido";

interface IMenuLateralContext {
    /** Menu em modo rail (só ícones) no desktop. */
    recolhido: boolean;
    alternarRecolhido: () => void;
    /** Menu temporário do mobile. */
    mobileAberto: boolean;
    abrirMenuMobile: () => void;
    fecharMenuMobile: () => void;
    /** Largura ocupada pelo menu no desktop, em pixels. */
    largura: number;
}

export const MenuLateralContext = createContext({} as IMenuLateralContext);

export const useMenuLateralContext = () => useContext(MenuLateralContext);

export const MenuLateralProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [recolhido, setRecolhido] = useState(() => localStorage.getItem(CHAVE_STORAGE) === "true");
    const [mobileAberto, setMobileAberto] = useState(false);

    const alternarRecolhido = useCallback(() => {
        setRecolhido(anterior => {
            const proximo = !anterior;
            localStorage.setItem(CHAVE_STORAGE, String(proximo));
            return proximo;
        });
    }, []);

    const abrirMenuMobile = useCallback(() => setMobileAberto(true), []);
    const fecharMenuMobile = useCallback(() => setMobileAberto(false), []);

    const valor = useMemo<IMenuLateralContext>(() => ({
        recolhido,
        alternarRecolhido,
        mobileAberto,
        abrirMenuMobile,
        fecharMenuMobile,
        largura: recolhido ? LARGURA_MENU_RECOLHIDO : LARGURA_MENU_EXPANDIDO,
    }), [recolhido, alternarRecolhido, mobileAberto, abrirMenuMobile, fecharMenuMobile]);

    return (
        <MenuLateralContext.Provider value={valor}>
            {children}
        </MenuLateralContext.Provider>
    );
};
